<template>
  <div>
    <div class="cont">
        <div class="cont-w">
            <slider ref="slider" :options="sliderinit">
                <!-- 直接使用slideritem slot -->
                <slideritem v-for="(item,index) in someList" :key="index" :style="item.style">
                    <img :src="imgurl(item.url)" width="1920" />
                </slideritem>
                <!-- 设置loading,可自定义 -->
            </slider>
        </div>
        <div class="search">
            <img src="@/assets/search.png" />
            <input type="text" v-model="shippingNum" placeholder="输入单号为您智能查询" />
            <div class="searbtn" @click="searbtn">搜索</div>
        </div>
    </div>
    <div class="sjtj">
        <div>
            <img src="@/assets/zhuccl.png" width="66" height="66" />
            <div class="num">12,614</div>
            <div>注册车辆（辆）</div>
        </div>
        <div>
            <img src="@/assets/hys.png" width="66" height="66" />
            <div class="num">49,103</div>
            <div>完成货运数（单）</div>
        </div>
        <div>
            <img src="@/assets/fhl.png" width="66" height="66" />
            <div class="num">843,081</div>
            <div>累计发货量（吨）</div>
        </div>
        <div>
            <img src="@/assets/cje.png" width="66" height="66" />
            <div class="num">23,138</div>
            <div>累计成交额（万元）</div>
        </div>
    </div>
      <div class="shissjbg">
          <div class="shidata">
              <div class="list">
                  <div class="sstit">
                      <img src="@/assets/sjtit.png" width="20" height="20" />
                      <span>实时数据</span>
                  </div>
                  <div class="listitem" v-for="(n,i) in list" :key="i">
                      <img src="@/assets/list-c.png" width="36" height="36" />
                      <div style="width:110px;margin:0 10px 0 20px;" class="chaocyc">{{n.sendAddressName}}</div>
                      <img src="@/assets/jiant.png" width="36" height="6" />
                      <div style="width:110px;margin:0 20px 0 10px;" class="chaocyc">{{n.receiveAddressName}}</div>
                      <img src="@/assets/time.png" width="18" height="18" />
                      <div style="width:50px;margin-left:10px;" class="chaocyc">白天</div>
                      <div style="width:110px;margin-left:20px;" class="chaocyc">{{n.quantity}}吨/{{n.goodsType}}</div>
                      <div style="width:110px;margin-left:20px;" class="chaocyc">2000元/吨公里价格</div>
                      <div style="width:180px;margin-left:20px;" class="chaocyc">巨力索具股份有限公司配货</div>
                  </div>
                  <div v-if="isMore" class="nodata">暂无数据</div>
                  <div class="more" v-if="morebtn">
                      <router-link to="/huoyunxx">
                          更多数据 》
                      </router-link>
                    </div>
              </div>
              <div>
                <div class="tongzhi">
                    <div>
                        <div class="titcont">
                            <div class="tztit">
                                <img src="@/assets/tongzhi.png" width="20" height="20" />
                                <span style="margin-left:15px">通知消息</span>
                            </div>
                            <div v-if="xiaoxtotal" style="color:#AEACAC;cursor:pointer;" @click="topage">
                                更多>>
                            </div>
                        </div>
                        <div class="tongzlist" v-for="(n,i) in xiaoxitzlist" :key="i" @click="totzdetails(n.id)">
                            <div class="tongzbiaot">
                                <div class="chaocyc" style="width:200px;"><span style="font-size:24px;">· </span>{{n.title}}</div>
                                <div>{{datefilter(n.createTime)}}</div>
                            </div>
                            <div class="chaocyc" style="width:340px;margin-top:10px;font-size:12px;color:#AEACAC">{{n.briefStr}}</div>
                        </div>
                        <div v-if="xiaoximore" class="nodata">暂无通知</div>
                    </div>
                </div>
                <div class="dingwei" @click="huowugz">
                    <img src="@/assets/dingwei.png" width="68" height="68" />
                    <div style="margin:10px 0;font-size:28px;">跟踪货物</div>
                    <div style="font-size:20px;">点击查看货物详情</div>
                </div>
              </div>
          </div>
      </div>
      <div class="cont_tit" style="padding:50px 0;background:#085998;color:#fff;">
          <div class="ywcjms" style="color:#fff;">业务场景</div>
          <div>提供专业高效的供应链服务</div>
      </div>
      <div class="yewucj">
            <div class="hszgq">
                <div class="chanjdwei" @click="topagejlcy" @mouseover="mouseOver" @mouseleave="mouseLeave">
                    <div>
                        <img src="@/assets/huoyd.png" width="51" height="51" />
                        <div>货源单</div>
                    </div>
                    <div v-show="hydshow" class="changjjs">
                        <div style="font-size:18px;">货源单</div>
                        <div>发货人/发货企业将需要运输的货源信息发布到平台上生成货源单，发布到货源大厅</div>
                        <div>了解更多</div>
                    </div>
                </div>
                <div class="chanjdwei" @click="topagejlcy" @mouseover="mouseOver1" @mouseleave="mouseLeave1">
                    <div>
                        <img src="@/assets/huoyd.png" width="51" height="51" />
                        <div>司机接单</div>
                    </div>
                    <div v-show="sjdjshow" class="changjjs">
                        <div style="font-size:18px;">司机接单</div>
                        <div>司机/车队可在货源大厅中承运心仪的货源单</div>
                        <div>了解更多</div>
                    </div>
                </div>
                
                <div class="chanjdwei" @click="topagejlcy" @mouseover="mouseOver2" @mouseleave="mouseLeave2">
                    <div>
                        <img src="@/assets/zhys.png" width="51" height="51" />
                        <div>装货运输</div>
                    </div>
                    <div v-show="zhysshow" class="changjjs">
                        <div style="font-size:18px;">装货运输</div>
                        <div>司机接单成功后到发货地确认装货，开始订单运输</div>
                        <div>了解更多</div>
                    </div>
                </div>

                <div class="chanjdwei" @click="topagejlcy" @mouseover="mouseOver3" @mouseleave="mouseLeave3">
                    <div>
                        <img src="@/assets/gcgz.png" width="51" height="51" />
                        <div>过程跟踪</div>
                    </div>
                    <div v-show="gcgzshow" class="changjjs">
                        <div style="font-size:18px;">过程跟踪</div>
                        <div>货源单运输过程中可进行车辆位置监控，实时货物跟踪</div>
                        <div>了解更多</div>
                    </div>
                </div>
                <div class="chanjdwei" @click="topagejlcy" @mouseover="mouseOver4" @mouseleave="mouseLeave4">
                     <div>
                        <img src="@/assets/qsxh.png" width="51" height="51" />
                        <div>签收卸货</div>
                    </div>
                    <div v-show="qsxhshow" class="changjjs">
                        <div style="font-size:18px;">签收卸货</div>
                        <div>货物运输完成后，确认卸货，签收</div>
                        <div>了解更多</div>
                    </div>
                </div>
            </div>
            <div style="width:1280px;margin-top:20px;">
                <el-steps 
                  style="margin-left:120px;">
                    <el-step title=""></el-step>
                    <el-step title=""></el-step>
                    <el-step title=""></el-step>
                    <el-step title=""></el-step>
                    <el-step title=""></el-step>
                </el-steps>
            </div>
      </div>
      <div class="cont_tit">
          <div class="ywcjms">新闻咨询</div>
          <div>新闻动态抢先看，创新与进步只为给您带来卓越体验</div>
      </div>
      <div class="newsbg">
          <div class="newscont">
                <div class="newslist" v-show="hangyenews">
                    <div class="newstit">
                        <div style="margin-left:20px;">行业新闻 / INDUSTRY NEWS</div>
                        <!-- <div style="font-size:16px;color:#ed9c0d;cursor: pointer;">更多 》</div> -->
                    </div>
                    <div style="padding-left:40px;">
                        <div class="listiteam" v-for="(n,i) in hynewslist" :key="i">
                            <div class="listtit" @click="tonewsdet(n.id)">
                                <div style="width:370px;font-size:16px;" class="chaocyc">{{n.newsTitle}}</div>
                                <div>{{datefilter(n.createTime)}}</div>
                            </div>
                            <!-- <div class="xinwenms">1月1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发</div> -->
                        </div> 
                    </div>
                    <div v-if="newshymore" class="nodata" style="margin-top:150px;">暂无数据</div>
                </div>
                <div class="newslist" v-show="gongsinews">
                    <div class="newstit">
                        <div style="margin-left:20px;">公司新闻 / INDUSTRY NEWS</div>
                        <div style="font-size:16px;color:#ed9c0d;cursor: pointer;">更多 》</div>
                    </div>
                    <div style="padding-left:40px;">
                        <div class="listiteam">
                            <div class="listtit">
                                <div style="width:370px;font-size:16px;" class="chaocyc">政策有变</div>
                                <div>2021/05/06</div>
                            </div>
                            <div class="xinwenms">1月1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发</div>
                        </div> 
                    </div>
                    <div v-if="zwsjshow1" class="nodata" style="margin-top:150px;">暂无数据</div>
                </div>
                <div class="newslist" v-show="wlwhnews">
                    <div class="newstit">
                        <div style="margin-left:20px;">物流文化 / INDUSTRY NEWS</div>
                        <div style="font-size:16px;color:#ed9c0d;cursor: pointer;">更多 》</div>
                    </div>
                    <div style="padding-left:40px;">
                        <div class="listiteam">
                            <div class="listtit">
                                <div style="width:370px;font-size:16px;" class="chaocyc">政策有变</div>
                                <div>2021/05/06</div>
                            </div>
                            <div class="xinwenms">1月1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发1日，高速按轴收费政策实施后，高速拥堵，ETC故障问题成了人们热议的焦点。这也为即将到来的春运，增加了压力。1月9日，国务院新闻办举行了春运发</div>
                        </div> 
                    </div>
                    <div v-if="zwsjshow2" class="nodata" style="margin-top:150px;">暂无数据</div>
                </div>
                <!-- <div class="newtab">
                    <div>
                        <img src="@/assets/news1.png" width="86" height="86" @click="newstab(1)" />
                    </div>
                    <div>
                        <img src="@/assets/news2.png" width="86" height="86" @click="newstab(2)" />
                    </div>
                    <div>
                        <img src="@/assets/news3.png" width="86" height="86" @click="newstab(3)" />
                    </div>
                </div> -->
          </div>
      </div>
  </div>
</template>

<script>
//import Banner from '../components/banner/banner'
import {slider,slideritem } from 'vue-concise-slider'
import { getRotation,notDoneOrder,queryUsedNews,jlSmsHistory } from '@/utils/service'
import { wtUrl } from '@/utils/confing'
import mymixins from '@/mixins'
export default {
    mixins:[mymixins],
    components:{
       // Banner,
        slider,
        slideritem
    },
    data(){
        return {
            xiaoxitzlist:[],
            hynewslist:[],
            xiaoxtotal:false,
            xiaoximore:false,
            newshymore:false,
            hangyenews:true,
            wlwhnews:false,
            gongsinews:false,
            zwsjshow:false,
            zwsjshow1:false,
            zwsjshow2:false,
            shippingNum:'',
            isMore:false,
            morebtn:false,
            infor:{},
            hydshow:false,
            sjdjshow:false,
            zhysshow:false,
            gcgzshow:false,
            qsxhshow:false,
            someList:[],
            list:[],
            sliderinit: {
                currentPage: 0,//当前页码
                thresholdDistance: 500,//滑动判定距离
                thresholdTime: 100,//滑动判定时间
                autoplay:3000,//自动滚动[ms]
                loop:true,//循环滚动
                //direction:'vertical',//方向设置，垂直滚动
               infinite:1,//无限滚动前后遍历数
               slidesToScroll:1,//每次滑动项数
            }
        }
    },
    methods:{
        tonewsdet(id){
            this.$router.push({
            path:'/details',
            query:{
              id
            }
          })
        },
        //新闻类型切换
        newstab(type){
            if(type == 1){
                this.hangyenews = true
                this.wlwhnews = false
                this.gongsinews = false
            }else if(type == 2){
                this.hangyenews = false
                this.wlwhnews = true
                this.gongsinews = false
            }else if(type == 3){
                this.hangyenews = false
                this.wlwhnews = false
                this.gongsinews = true
            }
        },
        searbtn(){
            if(this.shippingNum == ''){
                this.$alert('请输入正确的订单号后为您查询!', '温馨提示', {
                    type:'warning',
                    confirmButtonText: '确定'
                })
            }else{
                this.$router.push({
                    path:'/huowgz',
                    query:{
                        shippingNum:this.shippingNum
                    }
                })
            }
            
        },
        huowugz(){
            this.$router.push({
                path:'/huowgz'
            })
        },
        topagejlcy(){
            location.href = wtUrl
        },
        topage(){
            this.$router.push('/tongzhixx')
        },
        totzdetails(id){
            this.$router.push({
            path:'/tongzhidetails',
            query:{
              id
            }
          })
        },
        mouseOver(){
            this.hydshow = true
        },
        mouseLeave(){
            this.hydshow = false
        },
        mouseOver1(){
            this.sjdjshow = true
        },
        mouseLeave1(){
            this.sjdjshow = false
        },
        mouseOver2(){
            this.zhysshow = true
        },
        mouseLeave2(){
            this.zhysshow = false
        },
        mouseOver3(){
            this.gcgzshow = true
        },
        mouseLeave3(){
            this.gcgzshow = false
        },
        mouseOver4(){
            this.qsxhshow = true
        },
        mouseLeave4(){
            this.qsxhshow = false
        }
    },
    created(){
        //获取焦点图
        getRotation().then(data =>{
            if(data && data.length > 0){
                data.forEach(n => {
                    console.log(n,'123')
                    this.someList.push({
                        url:n.imgUrl,
                        style: {
                            'height':'400px'
                        }
                    })
                })
            }
        })

        //查询货源
        notDoneOrder({
            pageNo:1,
            pageSize:5
        }).then(rps =>{
            if(rps.records.length > 0){
                this.list = [...this.list,...rps.records]
            }
            if(rps.total == 0){
                this.isMore = true
                //this.more = '暂无数据'
            }
            if(rps.pages*1 > 1){
                this.morebtn = true
            }
        })

        //查询新闻列表
        queryUsedNews({
            pageNo:1,
            pageSize:3
        }).then(rps =>{
            if(rps.records.length > 0){
                this.hynewslist = rps.records
                
            }else{
                this.newshymore = true
            }
            // if(this.total == 0){
            //     this.isMore = false
            // }
        })
        //获取消息通知
        jlSmsHistory({
            pageNo:1,
            pageSize:3
        }).then(rps =>{
            if(rps.records.length > 0){
                this.xiaoxitzlist = rps.records
                
            }else{
                this.xiaoximore = true
            }
            if(rps.total > 3){
                this.xiaoxtotal = true
                //this.more = '暂无数据'
            }
            
        })

        
    },
    mounted(){
        
    }
}
</script>

<style lang="stylus" scoped>
    .cont
        padding-bottom: 30px
        //height: 400px
        background: #085998
        //margin-top:-130px 
        //padding-top:600px 
        //background:url('../../../assets/banerbg.jpg') no-repeat top center
        .cont-w
          //width: 1400px
          margin: 0 auto
    .cont_tit
        margin: 100px 0
        text-align: center
        .ywcjms
            margin-bottom:18px
            font-size: 24px
            font-weight:bold
            color:#085998
    .search
        position relative
        display:-webkit-box
        display: -webkit-flex
        display: flex
        align-items: center
        width: 710px
        height: 56px
        margin: 30px auto 0
        padding-left: 45px
        line-height: 56px
        background: #9DBBE5
        border-radius: 30px
        input
            width:500px 
            border: none
            font-size: 16px
            color: #fff  //#08599A
            background: #9DBBE5
        .searbtn
            position: absolute
            top: 0
            right: 0
            width: 100px
            text-align: center
            border-radius: 50px
            color: #fff
            background: #ED9C0D
            cursor pointer
    .sjtj
        display:-webkit-box
        display: -webkit-flex
        display: flex
        width: 900px
        margin: 50px auto
        padding 50px 110px
        -moz-box-shadow:2px 2px 5px #ccc 
        -webkit-box-shadow:2px 2px 5px #ccc 
        box-shadow:2px 2px 5px #ccc
        justify-content:space-between
        background: #fff
        div
            text-align: center
            .num
                padding: 15px 0 10px 0
                font-size: 28px
                font-weight: bold
    .shissjbg
        background: #eef6ff
        .shidata
            display:-webkit-box
            display: -webkit-flex
            display: flex
            width: 1120px
            margin: 0 auto
            justify-content: space-between
            padding: 40px 0
            cursor pointer
            .list
                width: 750px
                padding:20px 10px
                background: #fff
                .sstit
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items:center 
                    justify-content:center
                    font-size: 16px
                    color: #08599A
                    font-weight: bold
                    span
                        margin-left: 10px
                .listitem
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    height: 90px
                    line-height: 90px
                    align-items:center 
                    border-bottom: 1px solid #ccc
                .more
                    margin-top: 30px
                    text-align: center
                    color: #aeacac
        .tongzhi
            width: 280px
            //margin-left: 100px
            padding: 20px
            background: #fff
            .titcont
                display:-webkit-box
                display: -webkit-flex
                display: flex
                align-items:center
                justify-content: space-between
                padding-bottom: 20px
                border-bottom: 1px solid #ccc
            .tztit
                display:-webkit-box
                display: -webkit-flex
                display: flex
                align-items:center
                font-size: 16px
                color:#08599A
            .tongzlist
                padding:15px 0
                border-bottom: 1px #ccc dotted
                cursor:pointer
                .tongzbiaot
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items:center
                    justify-content: space-between
                    margin-bottom: 6px
        .dingwei
            width:320px
            height: 190px
            margin-top: 30px
            padding-top: 30px
            text-align:center
            color: #fff
            background:url('../../assets/changjibej.png') no-repeat top center
            background-size:100% 100%
    .yewucj
        width: 1400px
        margin: 0 auto
        padding-bottom: 20px
        .hszgq
            display:-webkit-box
            display: -webkit-flex
            display: flex
            justify-content: space-around
            .chanjdwei
                position relative
                .changjjs
                    width: 194px
                    height: 200px
                    position: absolute
                    top:-60px
                    left:-110px
                    padding 50px 20px 0
                    //background:#085998
                    background:url('../../assets/changjibej.png') no-repeat top center
                    text-align: center
                    color: #fff
                    z-index 99
                    cursor pointer
                    div
                        margin-bottom: 15px
                        line-height: 22px
    .newsbg
         margin-bottom: 140px
         background:url('../../assets/newsbg.jpg') no-repeat top center
         //background:url('../../assets/newsbg.jpg') no-repeat 0 0
         background-color:#085998
        .newscont
            display:-webkit-box
            display: -webkit-flex
            display: flex
            width:1100px
            height: 420px
            margin: 0 auto
            padding:60px 0
            color: #fff
            .newslist
                width:580px
                .newstit
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items: center
                    justify-content: space-between
                    width:92%
                    margin-bottom: 40px
                    font-size:28px
                    border-left:4px #fff solid
                .listiteam
                    width:500px
                    padding: 20px 0
                    border-bottom: 1px #ccc dotted
                    cursor pointer
                .listtit
                    display:-webkit-box
                    display: -webkit-flex
                    display: flex
                    align-items: center
                    justify-content: space-between
                    margin-bottom: 15px
                .xinwenms
                    display: -webkit-box
                    height: 42px
                    overflow: hidden
                    text-overflow: ellipsis
                    -webkit-line-clamp: 2
                    -webkit-box-orient: vertical
                    line-height: 20px
    .chaocyc
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
    .nodata
        width: 100%
        margin: 30px 0
        text-align: center
        font-size: 20px
    .newtab
        div
         margin-bottom: 60px
         cursor:pointer
</style>